import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'dateEvent'
})
export class DateEventPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, private translate_service: TranslocoService) {

  }

  /**
   * Date result for internal use of component.
   *
   * @type {{
    *     isSameDay: boolean,
    *     isSameYear: boolean,
    *     isSameMonth: boolean,
    *     first: Date,
    *     last: Date
    *   }}
    * @memberof DateEventPipe
    */
  dateResult: {
    isSameDay: boolean,
    isSameYear: boolean,
    isSameMonth: boolean,
    first: Date,
    last: Date | string
  };

  /**
 * A method for calculate the ranged date and check if is the same day
 *
 * @param {Date | string} dateFromPipe date from parameter
 * @param {Date | string} dateToPipe date ${word} parameter
 * @returns
 * @memberof DateEventPipe
 */
  calculateDateRange(dateFromPipe: Date | string, dateToPipe: Date | string) {
    const dateFrom = new Date(dateFromPipe);
    const dateTo = dateFromPipe != undefined ? new Date(dateToPipe) : 'Not DateTo';
    return {
      isSameDay: dateFrom.toString() === dateTo.toString(),
      isSameYear: dateTo instanceof Date ? dateFrom.getFullYear() === dateTo.getFullYear() : false,
      isSameMonth: dateTo instanceof Date ? dateFrom.getMonth() === dateTo.getMonth() : false,
      first: dateFrom,
      last: dateTo
    };
  }
  /**
    * A method for get the string of a date.
    *
    * @param {Date | string} date_from date from parameter
    * @param {Date | string} date_to date to parameter
    * @param {string} word the word used to separate dates.
    * @returns {string}
    * @memberof DateEventPipe
  */
  writeDate(date_from: string | Date, date_to: string | Date, word: string) {
    if (this.dateResult.isSameDay || date_from == undefined) {
      return this.datePipe.transform(date_from, 'd MMMM yyyy');
    }
    if (this.dateResult.isSameMonth && this.dateResult.isSameYear) {
      return `${this.datePipe.transform(date_from, 'd')} ${word} ${this.datePipe.transform(date_to, 'd MMMM yyyy')}`;
    }
    if (!this.dateResult.isSameMonth && this.dateResult.isSameYear) {
      return `${this.datePipe.transform(date_from, 'd MMM')} ${word} ${this.datePipe.transform(date_to, 'd MMM yyyy')}`;
    }
    if (!this.dateResult.isSameMonth && !this.dateResult.isSameYear) {
      return `${this.datePipe.transform(date_from, 'd MMM yyyy')} ${word} ${this.datePipe.transform(date_to, 'd MMM yyyy')}`;
    }

  }
    /**
    *
    * {@inheritdoc}
    *
    * @memberof DateEventPipe
  */
  transform(value: any, date_from: Date | string, date_to: Date | string, separator: string): any {
    const word = this.translate_service.translate(separator);
    this.dateResult = this.calculateDateRange(date_from, date_to);

    return this.writeDate(date_from, date_to, word);
  }

}
